import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { useParams } from 'react-router-dom';
import { useNavigate } from "react-router-dom";

export const EmailList = () => {

//   const { resultId } = useParams();
// const navigate = useNavigate();

//   // const handleSubmit = async () => {
  //   navigate('/results/' + resultId);
  // };

  return (
    <View style={styles.container}>
      <Text style={styles.message}>You have been added to the email list!</Text>
      {/* <View>
        <TouchableOpacity
          style={[
            styles.actionButton]}
          onPress={() => handleSubmit()}
        >
          <Text style={styles.actionText}>Back To Results</Text>
        </TouchableOpacity>
      </View> */}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'fixed',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  message: {
    color: '#3B1C15',
    fontSize: 30,
    textAlign: 'center',
    fontFamily: 'DM Sans',
    padding: 10,
    fontWeight: 400,
    overflow: 'visible',

  },
  actionButton: {
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#9EA698',
    width: 300,
    height: 82,

  },
  actionText: {
    fontFamily: 'DM Serif Display',
    fontSize: 30,
    color: '#FFFFFF',
    textAlign: 'center',
    fontWeight: '400',
  },
});
